"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EnumTypes = /** @class */ (function () {
    function EnumTypes() {
    }
    EnumTypes.busyStatus = 'BusyStatus';
    EnumTypes.cartType = 'CartType';
    EnumTypes.companyType = 'CompanyType';
    EnumTypes.contactType = 'ContactType';
    EnumTypes.countryCode = 'CountryCode';
    EnumTypes.customFieldCategory = 'CustomFieldCategory';
    EnumTypes.documentOfflineState = 'DocumentOfflineState';
    EnumTypes.documentType = 'DocumentType';
    EnumTypes.emailOfflineState = 'EmailOfflineState';
    EnumTypes.globalSettingsCategory = 'GlobalSettingsCategory';
    EnumTypes.goalType = 'GoalType';
    EnumTypes.journalType = 'JournalType';
    EnumTypes.knowledgeType = 'KnowledgeType';
    EnumTypes.leadType = 'LeadType';
    EnumTypes.marketingType = 'MarketingType';
    EnumTypes.paymentType = 'PaymentType';
    EnumTypes.productType = 'ProductType';
    EnumTypes.projectType = 'ProjectType';
    EnumTypes.salaryType = 'SalaryType';
    EnumTypes.taskType = 'TaskType';
    EnumTypes.usStatesDistrictsTerritories = 'USStatesDistrictsTerritories';
    EnumTypes.vacationType = 'VacationType';
    EnumTypes.workReportType = 'WorkReportType';
    return EnumTypes;
}());
exports.default = EnumTypes;
